// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 이벤트 관리 페이지 스타일
 */

.event-manage-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #FFF3E0 0%, #FCE4EC 100%);
  display: flex;
  flex-direction: column;
}

/* 헤더 */
.evm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.evm-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}

.evm-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #E65100;
  margin: 0;
  user-select: none;
  -webkit-user-select: none;
}

.evm-header-spacer {
  width: 72px;
}

.evm-header .btn-back {
  background: none;
  border: 2px solid #FF9800;
  color: #E65100;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
}

.evm-header .btn-back:active {
  background: #FF9800;
  color: #fff;
}

/* 콘텐츠 */
.evm-content {
  flex: 1 1;
  padding: 16px 20px;
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
}

/* 생성 버튼 */
.btn-create-event {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #FF9800, #F57C00);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  margin-bottom: 16px;
}

.btn-create-event:active {
  transform: scale(0.97);
}

/* 생성 폼 */
.evm-form-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.evm-form-card h3 {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #E65100;
  margin: 0 0 16px;
}

.evm-field {
  margin-bottom: 12px;
}

.evm-field label {
  display: block;
  font-size: 13px;
  color: #777;
  margin-bottom: 4px;
  font-weight: 500;
}

.evm-field input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E0E0E0;
  border-radius: 10px;
  font-size: 16px;
  min-height: 44px;
}

.evm-field input:focus {
  border-color: #FF9800;
  outline: none;
}

.evm-field-row {
  display: flex;
  gap: 10px;
}

.evm-field-row .evm-field {
  flex: 1 1;
}

.evm-form-error {
  color: #C62828;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.evm-form-buttons {
  display: flex;
  gap: 10px;
}

.btn-form-cancel {
  flex: 1 1;
  padding: 12px;
  background: #E0E0E0;
  color: #555;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
}

.btn-form-submit {
  flex: 1 1;
  padding: 12px;
  background: linear-gradient(135deg, #FF9800, #F57C00);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
}

.btn-form-submit:disabled {
  opacity: 0.5;
}

/* 로딩 */
.evm-loading {
  text-align: center;
  padding: 40px 0;
}

.evm-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #FFE0B2;
  border-top-color: #FF9800;
  border-radius: 50%;
  animation: evm-spin 0.8s linear infinite;
  margin: 0 auto 12px;
}

@keyframes evm-spin {
  to { transform: rotate(360deg); }
}

/* 빈 상태 */
.evm-empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.evm-empty span {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

/* 이벤트 카드 리스트 */
.evm-event-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.evm-event-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.evm-event-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.evm-event-name {
  font-family: 'Jua', sans-serif;
  font-size: 17px;
  color: #333;
}

.evm-event-coin {
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  padding: 4px 10px;
  border-radius: 16px;
}

.evm-event-coin.earn {
  background: #E8F5E9;
  color: #2E7D32;
}

.evm-event-coin.deduct {
  background: #FFEBEE;
  color: #C62828;
}

.evm-event-desc {
  font-size: 14px;
  color: #777;
  margin: 0 0 8px;
}

.evm-event-meta {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #999;
  margin-bottom: 10px;
}

.btn-end-event {
  width: 100%;
  padding: 10px;
  background: #FFEBEE;
  color: #C62828;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
}

.evm-end-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #C62828;
  font-weight: 600;
}

.btn-end-yes {
  padding: 8px 16px;
  background: #C62828;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.btn-end-no {
  padding: 8px 16px;
  background: #E0E0E0;
  color: #555;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.evm-error {
  margin-top: 16px;
  padding: 12px;
  background: #FFEBEE;
  color: #C62828;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
}

/* 공통 이벤트 안내 문구 */
.evm-common-note {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 6px 0;
  font-style: italic;
}

/* 공통 이벤트 배지 */
.evm-common-badge {
  display: inline-block;
  font-size: 11px;
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  background: #1E88E5;
  color: #fff;
  padding: 1px 6px;
  border-radius: 8px;
  margin-left: 6px;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EventManagePage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/**\n * 이벤트 관리 페이지 스타일\n */\n\n.event-manage-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #FFF3E0 0%, #FCE4EC 100%);\n  display: flex;\n  flex-direction: column;\n}\n\n/* 헤더 */\n.evm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.evm-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: pointer;\n}\n\n.evm-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #E65100;\n  margin: 0;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.evm-header-spacer {\n  width: 72px;\n}\n\n.evm-header .btn-back {\n  background: none;\n  border: 2px solid #FF9800;\n  color: #E65100;\n  font-size: 15px;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.evm-header .btn-back:active {\n  background: #FF9800;\n  color: #fff;\n}\n\n/* 콘텐츠 */\n.evm-content {\n  flex: 1;\n  padding: 16px 20px;\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  overflow-y: auto;\n}\n\n/* 생성 버튼 */\n.btn-create-event {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #FF9800, #F57C00);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n.btn-create-event:active {\n  transform: scale(0.97);\n}\n\n/* 생성 폼 */\n.evm-form-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.evm-form-card h3 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #E65100;\n  margin: 0 0 16px;\n}\n\n.evm-field {\n  margin-bottom: 12px;\n}\n\n.evm-field label {\n  display: block;\n  font-size: 13px;\n  color: #777;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.evm-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E0E0E0;\n  border-radius: 10px;\n  font-size: 16px;\n  min-height: 44px;\n}\n\n.evm-field input:focus {\n  border-color: #FF9800;\n  outline: none;\n}\n\n.evm-field-row {\n  display: flex;\n  gap: 10px;\n}\n\n.evm-field-row .evm-field {\n  flex: 1;\n}\n\n.evm-form-error {\n  color: #C62828;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.evm-form-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-form-cancel {\n  flex: 1;\n  padding: 12px;\n  background: #E0E0E0;\n  color: #555;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n}\n\n.btn-form-submit {\n  flex: 1;\n  padding: 12px;\n  background: linear-gradient(135deg, #FF9800, #F57C00);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n}\n\n.btn-form-submit:disabled {\n  opacity: 0.5;\n}\n\n/* 로딩 */\n.evm-loading {\n  text-align: center;\n  padding: 40px 0;\n}\n\n.evm-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #FFE0B2;\n  border-top-color: #FF9800;\n  border-radius: 50%;\n  animation: evm-spin 0.8s linear infinite;\n  margin: 0 auto 12px;\n}\n\n@keyframes evm-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* 빈 상태 */\n.evm-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: #999;\n}\n\n.evm-empty span {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n/* 이벤트 카드 리스트 */\n.evm-event-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.evm-event-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.evm-event-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.evm-event-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 17px;\n  color: #333;\n}\n\n.evm-event-coin {\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  padding: 4px 10px;\n  border-radius: 16px;\n}\n\n.evm-event-coin.earn {\n  background: #E8F5E9;\n  color: #2E7D32;\n}\n\n.evm-event-coin.deduct {\n  background: #FFEBEE;\n  color: #C62828;\n}\n\n.evm-event-desc {\n  font-size: 14px;\n  color: #777;\n  margin: 0 0 8px;\n}\n\n.evm-event-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #999;\n  margin-bottom: 10px;\n}\n\n.btn-end-event {\n  width: 100%;\n  padding: 10px;\n  background: #FFEBEE;\n  color: #C62828;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n}\n\n.evm-end-confirm {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #C62828;\n  font-weight: 600;\n}\n\n.btn-end-yes {\n  padding: 8px 16px;\n  background: #C62828;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-end-no {\n  padding: 8px 16px;\n  background: #E0E0E0;\n  color: #555;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.evm-error {\n  margin-top: 16px;\n  padding: 12px;\n  background: #FFEBEE;\n  color: #C62828;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* 공통 이벤트 안내 문구 */\n.evm-common-note {\n  font-size: 12px;\n  color: #999;\n  text-align: center;\n  padding: 6px 0;\n  font-style: italic;\n}\n\n/* 공통 이벤트 배지 */\n.evm-common-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-weight: 700;\n  background: #1E88E5;\n  color: #fff;\n  padding: 1px 6px;\n  border-radius: 8px;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
